import QuoteFormConfiguration from "./EcommerceQuoteFormConfiguration"

type EcommerceStyleMappingAttributes = {
    type: string
    styleMappings: CustomStyleMapping
    formConfigurations: []
}

export type CustomStyleMapping = {
    containerClass: string
    rowHeaderClass: string
    colLeftClass: string
    colClass: string
    colRightClass: string
    colFooterClass: string
    contentClass: string
    buttonLabel: string
    buttonPosition: string
    modalTitle: string
    rowClass: string
    groupClass: string
    boxClass: string
    labelClass: string
    buttonClass: string
    buttonColor: string
    buttonStyle: string
    cartToUse: string
    inputLabelPosition: string
    thankYouMessage: string
}

export type EcommerceStyleMappingDto = {
    id: string,
    type: string,
    attributes: EcommerceStyleMappingAttributes
}

export default class EcommerceStyleMapping {
    private dto: EcommerceStyleMappingDto
    constructor(dto: EcommerceStyleMappingDto) {
        this.dto = dto
    }

    getId(): string {
        return this.dto.id
    }

    getType(): string {
        return this.dto.attributes.type
    }

    getAttributes(): CustomStyleMapping {
        return this.dto?.attributes?.styleMappings
    }

    getAttributesAndForm(): EcommerceStyleMappingAttributes {
        return this.dto?.attributes
    }

    getFormConfiguration(): QuoteFormConfiguration[] {
        return this.dto?.attributes?.formConfigurations?.map(styleMapping => new QuoteFormConfiguration(styleMapping))
    }

    setFormConfiguration(config: QuoteFormConfiguration[]) {
        if (this.dto.attributes) {
            this.dto.attributes.formConfigurations = config as []
        }
    }

    setAttribute(field: string, value: string) {
        this.dto.attributes.styleMappings[field] = value
    }


}


// WEBPACK FOOTER //
// ./src/state/ecommerce-configuration/EcommerceStyleMapping.ts